var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn flex relative hover-z-10",class:[_vm.clss, _vm.height, _vm.fontSize],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }